import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import OrderViewEmployee from 'components/layout/order/OrderViewEmployee';
import OrderViewCustomer from 'components/layout/order/OrderViewCustomer';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import { ROLE_EMPLOYEE, ROLE_ROOT_EMPLOYEE } from 'js/constants';
import may from 'js/security';

class OrderDetailsIndex extends React.Component {
  render() {
    const {
      intl: { messages },
      user,
      orderData,
    } = this.props;

    const metaTitle = messages.order + ' - ' + orderData.id;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.order_details, metaTitle)}>
        {may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
          <OrderViewEmployee orderId={orderData.id} orderData={orderData} />
        ) : (
          <OrderViewCustomer orderId={orderData.id} orderData={orderData} />
        )}
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(OrderDetailsIndex));
